import React from 'react';
import FiatListTableTr from "./FiatListTableTr";
import { useTranslation } from '../../../Context/LanguageContext';

const FiatListTable = (props) => {
    const { t } = useTranslation();
    const { orders } = props;

    return (
        <>
            <div className="table-responsive">
                <div className="card-body pt-2 p-3">
                    <table className="table align-items-center mb-0">
                        <thead>
                            <tr>                                   
                                <th className="text-start text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                    {t('noOfHvam')}
                                </th>
                                <th className="text-start text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                    {t('priceOfHvam')}
                                </th>
                                <th className="text-start text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                    {t('totalPrice')}
                                </th>
                                <th className="text-start text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                    {t('currency')}
                                </th>
                                <th className="text-start text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-3">
                                    {t('transactionId')} 
                                </th>
                                <th className="text-start text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-3">
                                    {t('hashId')} 
                                </th>
                                <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                    {t('walletAddress')}
                                </th>
                                <th className="text-start text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                    {t('date')}
                                </th>
                                <th className="text-start text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                                    {t('status')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                orders && orders.length > 0 && orders.map((order, indx) => {
                                    return(
                                        <FiatListTableTr
                                            order={order}
                                            key={indx}
                                        />
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default FiatListTable